import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = '/insurancepolicy/charts';

const transformChartData = (response: any) => {
	const charts = response.charts || {};

	return charts;
};

export const usePoliciesReportingChartsQuery = ({
	filterRequest,
	enabled,
	refetchOnWindowFocus = false,
	charts,
}: {
	filterRequest: any;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	charts: any;
}) => {
	const userSession = useUserSession();
	return useQuery<any>({
		enabled,
		queryFn: async (): Promise<any> => {
			const response = await userSession.webServiceHelper.callAsync<any>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `insurancepolicy/charts`,
				}),
				'POST',
				{ filter: filterRequest, charts }
			);

			return transformChartData(response);
		},
		queryKey: [BASE_API_KEY, filterRequest, charts],
		refetchOnWindowFocus,
	});
};

export const invalidateAllPoliciesReportingCharts = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
};

export const invalidatePoliciesReportingCharts = ({ filterRequest }: { filterRequest: any }) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY, filterRequest] });
};
